module.exports = "/images/lamp.svg?2d851c59cab17d8bc0691b10934d3559";